import React from 'react';
interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  color?: 'emerald' | 'amber' | 'teal' | 'purple';
}
export function FeatureCard({
  icon,
  title,
  description,
  color = 'emerald'
}: FeatureCardProps) {
  const colorClasses = {
    emerald: 'bg-emerald-50 text-emerald-600 border-emerald-100',
    amber: 'bg-amber-50 text-amber-600 border-amber-100',
    teal: 'bg-teal-50 text-teal-600 border-teal-100',
    purple: 'bg-purple-50 text-purple-600 border-purple-100'
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 flex flex-col h-full" data-id="element-265">
      <div className={`${colorClasses[color]} p-3 rounded-full w-12 h-12 flex items-center justify-center mb-4`} data-id="element-266">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-267">{title}</h3>
      <p className="text-gray-700 flex-grow" data-id="element-268">{description}</p>
    </div>;
}